/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LinkMetadataDto
 */
export interface LinkMetadataDto {
    /**
     *
     * @type {string}
     * @memberof LinkMetadataDto
     */
    metadata?: string;
}

/**
 * Check if a given object implements the LinkMetadataDto interface.
 */
export function instanceOfLinkMetadataDto(
    value: object,
): value is LinkMetadataDto {
    return true;
}

export function LinkMetadataDtoFromJSON(json: any): LinkMetadataDto {
    return LinkMetadataDtoFromJSONTyped(json, false);
}

export function LinkMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LinkMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        metadata: json["metadata"] == null ? undefined : json["metadata"],
    };
}

export function LinkMetadataDtoToJSON(value?: LinkMetadataDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        metadata: value["metadata"],
    };
}
